// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS ProviderDetails INSTEAD.
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, sortBy } from 'lodash';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { Card, CardHeader, CardText, Divider, MoreOrLess } from '@unite-us/ui';
import addresses from "../../utils/addresses";
import groups from "../../utils/groups";
import Locations from "../../locations/Locations";
import { ProviderDescription } from "./components";

/**
 * @visibleName ProviderDetailsV2 DEPRECATED
*/

var ProviderDetailsV2 = function ProviderDetailsV2(props) {
  var center = props.center,
    className = props.className,
    clickableAddress = props.clickableAddress,
    initiallyCollapsed = props.initiallyCollapsed,
    openLink = props.openLink,
    provider = props.provider,
    providerLocations = props.providerLocations,
    showMore = props.showMore,
    title = props.title,
    intlProvider = props.intlProvider;
  var originLatLng = [center.lat, center.lng];
  var calculatedDistances = providerLocations.map(function (address) {
    return addresses.calculateDistance(address, originLatLng);
  });
  var locationsByDistance = sortBy(calculatedDistances, function (add) {
    return add.distanceVal;
  }) || [];
  var isInNetworkGroup = groups.isInNetworkGroup(provider);
  var titleText = !isEmpty(intlProvider) ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "LKNMNm",
    description: "about-header",
    defaultMessage: "About"
  }, function (txt) {
    return /*#__PURE__*/React.createElement("div", null, txt);
  }) : title;
  var containerRef = useRef(null);
  var handleMoreOrLessToggle = function handleMoreOrLessToggle() {
    if (containerRef.current) {
      containerRef.current.focus();
    }
  };
  return /*#__PURE__*/React.createElement(IntlProvider, {
    defaultLocale: "en",
    locale: intlProvider.locale,
    messages: intlProvider.messages
  }, /*#__PURE__*/React.createElement(Card, {
    className: classNames('provider-details mb-one', className),
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "provider-details__header",
    title: titleText
  }), /*#__PURE__*/React.createElement(CardText, null, initiallyCollapsed ? /*#__PURE__*/React.createElement(MoreOrLess, {
    onClick: handleMoreOrLessToggle
  }, /*#__PURE__*/React.createElement(ProviderDescription, {
    className: "provider-details__section",
    provider: provider,
    isInNetworkGroup: isInNetworkGroup,
    openLink: openLink,
    intlProvider: intlProvider
  }), !isEmpty(providerLocations) && /*#__PURE__*/React.createElement(Divider, {
    className: "provider-details__divider"
  }), /*#__PURE__*/React.createElement(Locations, {
    className: "provider-details__section",
    clickableAddress: clickableAddress,
    isInNetworkGroup: isInNetworkGroup,
    locations: locationsByDistance,
    showMore: showMore,
    intlProvider: intlProvider
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProviderDescription, {
    className: "provider-details__section",
    provider: provider,
    isInNetworkGroup: isInNetworkGroup,
    openLink: openLink,
    showMore: true,
    intlProvider: intlProvider
  }), !isEmpty(providerLocations) && /*#__PURE__*/React.createElement(Divider, {
    className: "provider-details__divider"
  }), /*#__PURE__*/React.createElement(Locations, {
    className: "provider-details__section mb-one",
    clickableAddress: clickableAddress,
    isInNetworkGroup: isInNetworkGroup,
    locations: locationsByDistance,
    showMore: true,
    intlProvider: intlProvider
  }))))));
};
ProviderDetailsV2.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  provider: PropTypes.object,
  initiallyCollapsed: PropTypes.bool,
  openLink: PropTypes.func,
  providerLocations: PropTypes.array,
  showMore: PropTypes.bool.isRequired,
  title: PropTypes.string,
  intlProvider: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.array
  })
};
ProviderDetailsV2.defaultProps = {
  center: {
    lat: 0,
    lng: 0
  },
  className: '',
  clickableAddress: false,
  provider: {},
  initiallyCollapsed: true,
  openLink: typeof window !== 'undefined' ? window.open : function () {},
  providerLocations: [],
  title: 'About',
  intlProvider: {
    locale: 'en',
    messages: []
  }
};
export default ProviderDetailsV2;